/**
 * @generated SignedSource<<ea7c7c2c4021191c97e1555cac501c72>>
 * @relayHash 4b5e9dde5572ad2b72b3d90ce64b430b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 39a3fc8907cb86d55c6ae136031c14763a4ab02065d1f2219030a30119b932af

import type { ConcreteRequest, Query } from 'relay-runtime';
export type MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery$variables = {
  spaceKey: string;
};
export type MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery$data = {
  readonly space: {
    readonly homepage: {
      readonly id: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery = {
  response: MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery$data;
  variables: MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "spaceKey"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "homepage",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "4b5e9dde5572ad2b72b3d90ce64b430b",
    "id": "39a3fc8907cb86d55c6ae136031c14763a4ab02065d1f2219030a30119b932af",
    "metadata": {},
    "name": "MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery",
    "operationKind": "query",
    "text": "query MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery($spaceKey:String!){space(key:$spaceKey){homepage{id},id}}"
  }
};
})();

(node as any).hash = "b2693b9e2134a1e0b43171db1726ae37";

export default node;
